/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import {
  ICustomerResponse,
  IPatientResponse,
  OptionTypeBase,
  SearchPaginateType,
  UserLightResponse,
} from "@advapacs/common";

export interface LinkedOrderDetail {
  id: string;
  accessionNumber: string;
  description: string;
  modality: string;
  occurrenceAt: string;
}

export interface ICriticalResult {
  id?: string;
  createdBy: UserLightResponse;
  createdAt: string;
  viewedAt?: string;
  acknowledgedAt?: string;
  patient?: IPatientResponse;
  clinicianPortal?: ICustomerResponse;
  hasReport?: boolean;
  description?: string;
  linkedOrder?: LinkedOrderDetail;
}

export interface ICriticalResultDetail {
  id?: string;
  createdBy: UserLightResponse;
  createdAt: string;
  viewedAt?: string;
  acknowledgedAt?: string;
  patient?: IPatientResponse;
  clinicianPortal?: ICustomerResponse;
  hasReport?: boolean;
  findings?: IFinding[];
  publicComment: string;
  linkedOrder?: LinkedOrderDetail;
}

export interface IStudyLightDiagnosticReport {
  id?: string;
  studyInstanceUid?: string;
  storageClasses?: Array<string>;
  sensitive?: boolean;
  accessionNumber: string;
  modalitiesInStudy?: Array<string>;
  dateTime?: string;
  description?: string;
}

export interface CriticalResultResponse {
  id: string;
  createdBy: UserLightResponse;
  createdAt: string;
  findings?: IFinding[];
  publicComment: string;
}

export interface IFinding {
  id: string;
  name: string;
}

export interface SearchPrams extends SearchPaginateType {
  statuses?: string[];
  patientName?: string;
  isFuzzySearch?: boolean;
  patientId?: string;
  accessionNumber?: string;
  customers?: Array<string>;
}

export interface SearchState extends SearchPaginateType {
  statuses?: OptionTypeBase[];
  patientName?: string;
  isFuzzySearch?: boolean;
  patientId?: string;
  accessionNumber?: string;
  customers?: OptionTypeBase[];
}

export const initSearch: Readonly<SearchState> = {
  statuses: null,
  patientName: "",
  isFuzzySearch: false,
  patientId: "",
  accessionNumber: "",
  customers: null,
};
